/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getClientes,
  getContratos,
  getIntermediarios,
  getNegociosCarteleria,
  getOportunidades,
  getOportunidadesBTL,
  getUsers,
  log,
} from "../../../utils";
// Fase 3.2b: "cobrada" del filtro/flag se resuelve por resolverCobroVenta (regla 10.264), no por el
// facturafechacobro crudo. cargarCobroPorVenta arma el mapa cobro-por-venta desde el libro (resolverSaldo).
import { generarFilasCarteleriaGrilla } from "../../../utils/carteleria/filasGrillaCarteleria";
import { cargarCobroPorVenta } from "../../../utils/cobro/cargarCobroVentas";
import { resolverCobroVenta } from "../../../utils/cobro/getCobroFactura";
import { cargarSnapshotPctCongelado } from "../../../utils/comisionSnapshot";
import { derivarDisplayFolio } from "../../../utils/derivarDisplayFolio";
import { getFactoringInfoPorFactura } from "../../../utils/factoring";
import { auditarDualRun } from "../../../utils/lineasFacturacion/auditarDualRun";
import { refKeyDeOportunidad, refKeyDeVinculacion, refKeyLegacyDeVinculacion } from "../../../utils/lineasFacturacion/refKey";
import { derivarClaveHardware, resolverLinea } from "../../../utils/lineasFacturacion/resolverLinea";
import { client } from "../../../utils/supabase";

const possibleYears = ["2024", "2025", "2026", "2027"];

export const useVFDataLoading = (pais, getUFValue, ratesLoaded) => {
  const [todasOportunidades, setTodasOportunidades] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [ejecutivosUnicos, setEjecutivosUnicos] = useState([]);
  const [siiMap, setSiiMap] = useState({});
  const [factoringMap, setFactoringMap] = useState(() => new Map());
  // A3 (7.22): % de intermediación congelado (foto). Vacío/null → todo en vivo.
  const [pctMap, setPctMap] = useState(null);

  useEffect(() => {
    if (!ratesLoaded) return;
    const initialize = async () => {
      try {
        const [
          allOportunidades,
          allIntermediarios,
          allClientes,
          allUsuarios,
          allContratos,
          allNegociosCarteleria,
          edificiosRes,
          pctFrozen,
        ] = await Promise.all([
          getOportunidades({ pais }),
          getIntermediarios({ pais }),
          getClientes({ pais }),
          getUsers(),
          getContratos({ pais }),
          getNegociosCarteleria({ pais }),
          client.from("edificios").select("id, edificio").eq("pais", pais),
          cargarSnapshotPctCongelado(pais).catch(() => null),
        ]);
        setPctMap(pctFrozen);
        const edificiosMap = (edificiosRes.data || []).reduce((acc, e) => ({ ...acc, [e.id]: e.edificio }), {});
        const clientesMap = allClientes.reduce((acc, c) => ({ ...acc, [c.id]: c.nombre }), {});
        const allOportunidadesBTLPromises = possibleYears.map((ano) => getOportunidadesBTL({ pais, ano }));
        const allOportunidadesBTLArrays = await Promise.all(allOportunidadesBTLPromises);
        const allOportunidadesBTL = allOportunidadesBTLArrays.flat();

        // Deduplicate BTL opportunities by ID
        const seenIds = new Set();
        const uniqueOportunidadesBTL = allOportunidadesBTL.filter((btl) => {
          if (seenIds.has(btl.id)) {
            return false;
          }
          seenIds.add(btl.id);
          return true;
        });

        // Mapear oportunidades regulares con el campo ejecutivo
        const mappedOportunidades = allOportunidades.map((op) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (op.mes_factura && typeof op.mes_factura === "string") {
            const [month, year] = op.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            ...op,
            type: "pauta",
            ejecutivo: op.ejecutivo ? parseInt(op.ejecutivo, 10) : null,
            mes,
            ano,
          };
        });

        // Mapear oportunidades BTL con executive_responsible
        const filteredOportunidadesBTL = uniqueOportunidadesBTL.filter(
          (btl) => btl.status === 100 && !btl.eliminada && btl.pais === pais
        );
        const mappedOportunidadesBTL = filteredOportunidadesBTL.map((btl) => {
          let mes = (new Date().getMonth() + 1).toString().padStart(2, "0");
          let ano = new Date().getFullYear().toString();
          if (btl.mes_factura && typeof btl.mes_factura === "string") {
            const [month, year] = btl.mes_factura.split("-");
            if (month && year) {
              mes = month.padStart(2, "0");
              ano = year;
            }
          }
          return {
            id: btl.id,
            client_id: btl.client_id,
            importe: btl.total_investment,
            comision: btl.total_commission,
            facturafecha: btl.facturafecha,
            facturanumero: btl.facturanumero,
            facturafechacobro: btl.facturafechacobro,
            mes,
            ano,
            estatus: "100%",
            eliminada: btl.eliminada,
            cliente: allClientes.find((c) => c.id === btl.client_id)?.nombre || "Desconocido",
            type: "BTL",
            moneda_dolar: btl.moneda_dolar || false,
            ejecutivo: btl.executive_responsible ? parseInt(btl.executive_responsible, 10) : null,
          };
        });

        // Explotar contratos: cada mes del JSONB → una fila facturable
        const mappedContratos = (allContratos || [])
          .filter((c) => !c.eliminada && c.estatus === "100%" && c.pais === pais)
          .flatMap((c) =>
            (c.meses || []).map((mesObj, idx) => {
              const [mesStr, anoStr] = (mesObj.mes || "01-2026").split("-");
              return {
                id: `contrato-${c.id}-${idx}`,
                contrato_id: c.id,
                mes_index: idx,
                client_id: c.client_id,
                importe: mesObj.importe || 0,
                comision: null,
                facturafecha: mesObj.facturafecha,
                facturanumero: mesObj.facturanumero,
                facturafechacobro: mesObj.facturafechacobro,
                plazocobro: mesObj.plazocobro,
                mes: mesStr,
                ano: anoStr,
                estatus: "100%",
                eliminada: false,
                cliente: allClientes.find((cl) => cl.id === c.client_id)?.nombre || c.cliente || "Desconocido",
                type: "contrato",
                // Acuerdos a nivel contrato (aplican a todos sus meses): APX (capa aditiva) y override
                // de volumen (ej. OMNET). Necesarios para que VentasFacturas muestre pill + % correcto
                // en las filas-mes de contrato, igual que en pauta (resolución por ID, regla 10.7).
                apx_id: c.apx_id,
                descuento_acuerdo_pct: c.descuento_acuerdo_pct,
                moneda_dolar: c.moneda_dolar || false,
                ejecutivo: c.ejecutivo ? parseInt(c.ejecutivo, 10) : null,
                campana: c.campana,
                label_extra: `Mes ${idx + 1}/${(c.meses || []).length}`,
                personas_comprometidas: c.personas_comprometidas,
                edificios_ids: mesObj.edificios_ids || null,
                pantallas_ascensores: mesObj.pantallas_ascensores || "",
                pantallas_espera: mesObj.pantallas_espera || "",
                pantallas_circulacion: mesObj.pantallas_circulacion || "",
                pantallas_cowork: mesObj.pantallas_cowork || "",
                pantallastotales: mesObj.pantallas_totales || 0,
                display_id: c.display_id || null,
              };
            })
          );

        // L6 tramo 4 (ex L2 dual-run "sombra"): cargar lineas_facturacion (L1, tabla derivada; NADIE la
        // escribe desde la app) y agruparla por negocio para resolver `linea_id` por clave natural.
        // Paginado por si supera el techo de 2000 filas del server (10.167). `linea_id` deja de ser
        // sombra: es la fuente de la refKey de lectura de cartelería/hardware (útil `refKey.js`, 10.1).
        const lineasPorNegocio = new Map();
        try {
          const PAGE = 1000;
          for (let desde = 0; ; desde += PAGE) {
            const { data: pageLineas, error: errLineas } = await client
              .from("lineas_facturacion")
              .select("id, negocio_id, tipo, ano, mes, tramo")
              .order("id", { ascending: true })
              .range(desde, desde + PAGE - 1);
            if (errLineas) {
              log.warn("useVFDataLoading.lineas_facturacion", errLineas);
              break;
            }
            (pageLineas || []).forEach((l) => {
              const k = String(l.negocio_id);
              if (!lineasPorNegocio.has(k)) lineasPorNegocio.set(k, []);
              lineasPorNegocio.get(k).push(l);
            });
            if (!pageLineas || pageLineas.length < PAGE) break;
          }
        } catch (e) {
          log.warn("useVFDataLoading.lineas_facturacion", e);
        }
        const resolverLineaId = (negocioId, clave) => {
          if (!clave) return null;
          return resolverLinea(lineasPorNegocio.get(String(negocioId)) || [], clave)?.id ?? null;
        };

        // Filas de cartelería (HW-CAPEX, HW-OPEX, Gestión): importes y meses salen del motor
        // `calendarioNegocio` (F3b, rediseño de Cartelería); la conversión, por el helper único. Resultado
        // idéntico fila por fila al bloque anterior (test `f3b.grilla.test.js`).
        const mappedCarteleria = generarFilasCarteleriaGrilla(allNegociosCarteleria, {
          clientesMap,
          edificiosMap,
          resolverLineaId,
          derivarClaveHardware,
          getUFValue,
        });

        // Cargar vinculaciones SII con detalle por concepto
        const { data: siiVinculadas } = await client
          .from("facturas_sii_emitidas")
          .select(
            "folio, id, fecha_emision, monto_neto, monto_exento, monto_total, tipo_dte, plazocobro, facturafechacobro, estado_factoring, " +
              "facturas_sii_vinculaciones(venta_tipo, venta_ref_id, venta_ref_index, linea_id, monto_aplicado)"
          )
          .eq("pais", pais)
          .eq("estado_vinculacion", "vinculada");

        // Fase 3.2b (10.264): mapa cobro-por-venta desde el libro (resolverSaldo). El filtro/flag
        // "cobrada" se deriva de acá vía resolverCobroVenta; las ventas sin documento fiscal (pre-SII)
        // caen al facturafechacobro manual (via='manual_pre_sii') dentro del helper.
        const cobroPorVenta = await cargarCobroPorVenta(pais).catch(() => new Map());

        // L6 tramo 4: `_byRef` se indexa por `refKeyDeVinculacion` (cartelería/hardware → `linea:<id>`,
        // pauta/BTL/contrato → la key legacy, sin cambios — 10.1). `_byRefLegacy` (SOLO dev, nunca se usa
        // para decidir nada) indexa la MISMA data por la key posicional vieja, para que el dual-run de
        // auditoría siga comparando método viejo vs método nuevo (antes comparaba posición vs sombra).
        const siiMapData = { _byRef: {} };
        const byRefLegacyDev = process.env.NODE_ENV !== "production" ? {} : null;
        (siiVinculadas || []).forEach((f) => {
          const montoNeto = f.monto_neto || f.monto_exento || 0;
          siiMapData[String(f.folio)] = {
            facturaId: f.id,
            montoNeto, // F3: para derivar la atribución (resolverAtribucionFactura) por factura
            vinculaciones: f.facturas_sii_vinculaciones || [],
            plazocobro: f.plazocobro ?? null,
            facturafechacobro: f.facturafechacobro ?? null,
            estadoFactoring: f.estado_factoring ?? null,
          };
          (f.facturas_sii_vinculaciones || []).forEach((v) => {
            const entry = {
              facturaId: f.id,
              folio: f.folio,
              fechaEmision: f.fecha_emision,
              montoNeto,
              montoAplicado: v.monto_aplicado ?? null, // F3: fuente única del importe por fila
              montoTotal: f.monto_total,
              tipoDte: f.tipo_dte,
              plazocobro: f.plazocobro ?? null,
              facturafechacobro: f.facturafechacobro ?? null,
              estadoFactoring: f.estado_factoring ?? null,
            };
            const key = refKeyDeVinculacion(v);
            if (key) siiMapData._byRef[key] = entry;
            if (byRefLegacyDev) {
              const legacyKey = refKeyLegacyDeVinculacion(v);
              if (legacyKey) byRefLegacyDev[legacyKey] = entry;
            }
          });
        });
        setSiiMap(siiMapData);

        // Operaciones de factoring activas/liquidadas → Map<factura_sii_emitida_id, {...}>
        // para la columna "Factoring" en la tabla de VentasFacturas. Fuente única (10.1/10.27):
        // getFactoringInfoPorFactura indexa por FK directa UNION puente — una op multi-factura
        // (413452) deja una entrada por CADA factura, no solo por la FK directa.
        setFactoringMap(await getFactoringInfoPorFactura(pais));

        // Override plazocobro y facturafechacobro desde SII si hay vinculación.
        // Además computa _displayFolio (folio de la vinculación por ID, fallback al texto
        // facturanumero) con la función única que también usa recargarSiiMap (P2.100).
        const injectSIIDates = (op) => {
          const key = refKeyDeOportunidad(op);
          const byRef = key ? siiMapData._byRef[key] : null;
          const bySII = byRef || (op.facturanumero && siiMapData[String(op.facturanumero)]) || null;
          const _displayFolio = derivarDisplayFolio(op, siiMapData);
          // Fase 3.2b (10.264): "cobrada" por venta. Con documento en el puente (key en cobroPorVenta) →
          // resolverSaldo; sin documento (pre-SII) → facturafechacobro manual (via='manual_pre_sii'). Se
          // usa la key de refKeyDeOportunidad (reuso, no duplica el switch de modelos). facturafechacobro para el
          // fallback = el propio de la venta (el bySII solo aplica a vinculadas, que resuelven por libro).
          const _cobroReal = resolverCobroVenta({ _key: key, facturafechacobro: op.facturafechacobro }, cobroPorVenta);
          if (!bySII) return { ...op, _displayFolio, _cobroReal };
          return {
            ...op,
            _displayFolio,
            _cobroReal,
            plazocobro: bySII.plazocobro ?? op.plazocobro,
            facturafechacobro: bySII.facturafechacobro ?? op.facturafechacobro,
          };
        };

        const combinedOportunidades = [
          ...mappedOportunidades,
          ...mappedOportunidadesBTL,
          ...mappedContratos,
          ...mappedCarteleria,
        ].map(injectSIIDates);

        // L2 · Auditoría del dual-run (SOLO desarrollo): un único log.info por carga con el resumen
        // (divergencias método posición↔clave natural — esperado 0 — y excepciones opex conocidas).
        // Nunca en producción, nunca por fila, nunca decide ni renderiza nada.
        if (process.env.NODE_ENV !== "production") {
          const auditoria = auditarDualRun(combinedOportunidades, siiMapData, byRefLegacyDev);
          log.info("VF dual-run L6 tramo 4 (key legacy vs linea_id)", {
            pais,
            filasCarteleria: auditoria.filas,
            conVinculo: auditoria.conVinculo,
            divergencias: auditoria.divergencias.length,
            clavesDivergentes: auditoria.divergencias.map((d) => d.refKey),
            excepcionesOpexConocidas: auditoria.excepcionesOpex.length,
            clavesExcepcionOpex: auditoria.excepcionesOpex.map((e) => e.refKey),
          });
        }

        setTodasOportunidades(combinedOportunidades);
        setIntermediarios(allIntermediarios);
        setClientes(allClientes);
        setUsuarios(allUsuarios);

        // Mapear ejecutivos únicos basados en los IDs con ventas al 100%
        const uniqueEjecutivoIds = [
          ...new Set(combinedOportunidades.map((op) => op.ejecutivo).filter((id) => id !== null)),
        ];
        const ejecutivosUnicosList = uniqueEjecutivoIds
          .map((ejecutivoId) => {
            const usuario = allUsuarios.find((u) => parseInt(u.id, 10) === ejecutivoId);
            return usuario ? { id: ejecutivoId, nombre: usuario.nombre } : null;
          })
          .filter((u) => u !== null)
          .sort((a, b) => a.nombre.localeCompare(b.nombre));
        setEjecutivosUnicos(ejecutivosUnicosList);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        log.error("initialize", error);
        toast.error("Error al cargar los datos iniciales");
      }
    };
    initialize();
  }, [pais, ratesLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const recargarSiiMap = async () => {
    const { data } = await client
      .from("facturas_sii_emitidas")
      .select(
        "folio, id, fecha_emision, monto_neto, monto_exento, monto_total, tipo_dte, plazocobro, facturafechacobro, " +
          "facturas_sii_vinculaciones(venta_tipo, venta_ref_id, venta_ref_index, linea_id, monto_aplicado)"
      )
      .eq("pais", pais)
      .eq("estado_vinculacion", "vinculada");
    const map = { _byRef: {} };
    (data || []).forEach((f) => {
      const montoNeto = f.monto_neto || f.monto_exento || 0;
      map[String(f.folio)] = {
        facturaId: f.id,
        montoNeto, // F3: para derivar la atribución por factura
        vinculaciones: f.facturas_sii_vinculaciones || [],
        plazocobro: f.plazocobro ?? null,
        facturafechacobro: f.facturafechacobro ?? null,
        estadoFactoring: f.estado_factoring ?? null,
      };
      (f.facturas_sii_vinculaciones || []).forEach((v) => {
        const key = refKeyDeVinculacion(v);
        if (!key) return;
        map._byRef[key] = {
          facturaId: f.id,
          folio: f.folio,
          fechaEmision: f.fecha_emision,
          montoNeto,
          montoAplicado: v.monto_aplicado ?? null, // F3: fuente única del importe por fila
          montoTotal: f.monto_total,
          tipoDte: f.tipo_dte,
          plazocobro: f.plazocobro ?? null,
          facturafechacobro: f.facturafechacobro ?? null,
          estadoFactoring: f.estado_factoring ?? null,
        };
      });
    });
    setSiiMap(map);
    // P2.100: `_displayFolio` sale del puente, así que se recalcula con el siiMap nuevo en cada fila (su
    // refKey sale de sus propios IDs, 10.7/10.234) — sin releer el dataset. Solo `_displayFolio`:
    // `_cobroReal`/`plazocobro`/`facturafechacobro` quedan como los dejó la carga (bloqueo Fase 3).
    setTodasOportunidades((prev) => {
      let cambio = false;
      const next = prev.map((op) => {
        const _displayFolio = derivarDisplayFolio(op, map);
        if (_displayFolio === op._displayFolio) return op;
        cambio = true;
        return { ...op, _displayFolio };
      });
      return cambio ? next : prev;
    });

    // Recargar también factoringMap (cuando se vincula/anula/liquida desde el modal DTE). Misma
    // fuente única que la carga inicial (10.1/10.27).
    setFactoringMap(await getFactoringInfoPorFactura(pais));
  };

  const isDataLoaded =
    todasOportunidades.length > 0 && intermediarios.length > 0 && clientes.length > 0 && usuarios.length > 0;

  return {
    todasOportunidades,
    setTodasOportunidades,
    intermediarios,
    clientes,
    usuarios,
    ejecutivosUnicos,
    siiMap,
    factoringMap,
    pctMap,
    recargarSiiMap,
    isDataLoaded,
  };
};
